export default function CTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-emerald-500 to-teal-600 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Bereit, dein Eqology-Business auf das nächste Level zu bringen?
          </h2>
          <p className="text-xl text-emerald-50 max-w-3xl mx-auto mb-8">
            Starte jetzt kostenlos und gewinne in den nächsten 30 Tagen deine ersten 5 neuen Partner – 
            ohne stundenlange Recherche, ohne erfolglose Kaltakquise.
          </p>
          <a
            href="/register"
            className="inline-flex items-center gap-3 bg-white text-emerald-600 px-8 py-4 rounded-xl font-bold text-lg hover:bg-emerald-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span>Jetzt kostenlos starten</span>
            <i className="ri-arrow-right-line text-2xl"></i>
          </a>
          <p className="text-emerald-100 mt-4 text-sm">
            ✓ Keine Kreditkarte erforderlich  ✓ In 2 Minuten einsatzbereit  ✓ Jederzeit kündbar
          </p>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center border border-white/20">
            <div className="text-5xl font-bold text-white mb-2">2.500+</div>
            <div className="text-emerald-50 text-lg">Gesundheitsprofis in deiner Region verfügbar</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center border border-white/20">
            <div className="text-5xl font-bold text-white mb-2">85%</div>
            <div className="text-emerald-50 text-lg">höhere Erfolgsquote durch gezielte Ansprache</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center border border-white/20">
            <div className="text-5xl font-bold text-white mb-2">10+</div>
            <div className="text-emerald-50 text-lg">Stunden pro Woche gespart</div>
          </div>
        </div>

        {/* Target Groups */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-12 border border-white/20">
          <h3 className="text-3xl font-bold text-white mb-8 text-center">
            Diese Zielgruppen warten auf deine Eqology-Produkte
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white/10 rounded-xl p-6 border border-white/20">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-heart-pulse-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-2">Herzgesundheit</h4>
              <p className="text-emerald-50 text-sm">
                Kardiologen, Internisten & Präventivmediziner – perfekt für Omega-3
              </p>
            </div>
            <div className="bg-white/10 rounded-xl p-6 border border-white/20">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-brain-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-2">Kognition</h4>
              <p className="text-emerald-50 text-sm">
                Neurologen, Psychiater & Gedächtnistrainer – interessiert an Brain Health
              </p>
            </div>
            <div className="bg-white/10 rounded-xl p-6 border border-white/20">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-leaf-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-2">Naturheilkunde</h4>
              <p className="text-emerald-50 text-sm">
                Heilpraktiker & Therapeuten – offen für Premium-Nahrungsergänzung
              </p>
            </div>
            <div className="bg-white/10 rounded-xl p-6 border border-white/20">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-run-line text-white text-2xl"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-2">Sportmedizin</h4>
              <p className="text-emerald-50 text-sm">
                Sportärzte & Trainer – brauchen hochwertige Supplements
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
